/**
 * TimeRangeSelector — Pill-style tabs for selecting price chart time intervals.
 *
 * Story 4.3 — Task 3
 */

import type { PriceInterval } from "@repo/shared-types";

import { cn } from "../../lib/cn";

const INTERVALS: Array<{ value: PriceInterval; label: string }> = [
	{ value: "1H", label: "1H" },
	{ value: "4H", label: "4H" },
	{ value: "1D", label: "1D" },
	{ value: "1W", label: "1W" },
];

type TimeRangeSelectorProps = {
	selected: PriceInterval;
	onIntervalChange: (interval: PriceInterval) => void;
};

export function TimeRangeSelector({ selected, onIntervalChange }: TimeRangeSelectorProps) {
	return (
		<div className="flex gap-1 overflow-x-auto" role="tablist" aria-label="Time range">
			{INTERVALS.map(({ value, label }) => (
				<button
					key={value}
					type="button"
					role="tab"
					aria-selected={selected === value}
					onClick={() => onIntervalChange(value)}
					className={cn(
						"px-3 py-1.5 text-xs font-medium rounded-lg transition-colors whitespace-nowrap",
						selected === value
							? "bg-pastel-vibrant-blue text-white"
							: "text-pastel-gray hover:bg-pastel-light-gray"
					)}
				>
					{label}
				</button>
			))}
		</div>
	);
}
